import { pb } from './pocketbase';

// Rechercher des centres par nom
export const searchCenters = async (query) => {
    try {
        if (!query || query.length < 2) {
            return [];
        }
        const result = await pb.collection('centers').getList(1, 10, {
            filter: `name ~ "${query}"`,
        });

        return result.items;
    } catch (error) {
        console.error('Erreur lors de la recherche des centres:', error);
        return [];
    }
};


// créer un centre
export const createCenter = async (centerData) => { // Renommé 'center' en 'centerData' pour la clarté
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const centerWithPartnerId = {
                ...centerData, // Garde toutes les autres données du centre
                partner_id: pb.authStore.record.partner_id
            };
            const result = await pb.collection('centers').create(centerWithPartnerId);
            return result;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le centre sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error('Erreur lors de la création du centre:', error);
        return null;
    }
};

// mettre à jour un centre
export const updateCenter = async (id, center) => { // Export this function
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const updatedCenter = await pb.collection('centers').update(id, center);
            return updatedCenter;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de mettre à jour le centre sans partner_id.');
            return null;
        }    
    } catch (error) {
        console.error('Erreur lors de la mise à jour du centre:', error);
        return null;
    }
};

// supprimer un centre
export const deleteCenter = async (id) => { // Export this function
    try {
        const result = await pb.collection('centers').delete(id);
        return result;
    } catch (error) {
        console.error('Erreur lors de la suppression du centre:', error);
        return null;
    }
};

export const getCenters = async ({ page = 1, perPage = 20, search = '', fullData = false }) => {
    try {
        const filter = search ? `name ~ "${search}" || siret_number ~ "${search}"` : ''; 
        const options = {
            filter: filter
        };
        
        if (!fullData) {
            options.fields = 'id,name,status,email,phone,address,address_complement,zip_code,city,is_company_cfa,main_cfa_location,logoUrl';
        }
        
        const result = await pb.collection('centers').getList(page, perPage, options);
        return result;
    } catch (error) {
        console.error('Erreur lors du chargement des centres:', error);
        throw error;
    }
};

// Récupérer un centre par son ID
export const getCenterById = async (id) => {
    try {
        const record = await pb.collection('centers').getOne(id);
        return record;
    } catch (error) {
        console.error(`Erreur lors de la récupération du centre ${id}:`, error);
        if (error.status === 404) {
            return null;
        }
        throw error;
    }
};

// Compter les contrats actifs pour un centre donné
export const countActiveCenterContracts = async (centerId) => {
    try {
        const result = await pb.collection('contracts').getList(1, 1, {
            filter: `center_id = "${centerId}" && actif = true`,
        });
        return result.totalItems;
    } catch (error) {
        console.error(`Erreur lors du comptage des contrats actifs pour le centre ${centerId}:`, error);
        return 0; // Retourne 0 en cas d'erreur pour éviter de casser l'interface
    }
};

// S'abonner aux changements de contrats pour un centre spécifique
export const subscribeToCenterContracts = (centerId, onContractChange) => {
    return pb.collection('contracts').subscribe('*', (e) => {
        if (e.record && e.record.center_id === centerId) {
            if (typeof onContractChange === 'function') {
                onContractChange(e);
            }
        }
    });
};

// Se désabonner des changements de contrats
export const unsubscribeFromContracts = (subscriptionId) => {
    if (subscriptionId) {
        pb.collection('contracts').unsubscribe(subscriptionId);
    }
};

